import React, {useState, useContext} from 'react';
import {loadState} from '../../../providers/localStorage';
import {texts } from './SolicitudPresentadaCorrectamenteData';
import AppContext from 'AppContext';
import {localStorageName} from '../../../providers/localStorageData';
import {properties as appProperties} from 'AppData';
import {useHistory} from "react-router-dom";
import { useSelector } from 'react-redux';

const useFunctions = () => {
    const history = useHistory();

    const PREFIJO_OBJETO_FILE_PDF = 'data:application/pdf;base64,';
    const NOMBRE_DOC_RECIBI = 'Recibi.pdf'
    const context = useContext(AppContext);

    //Hooks
    const [tituloPagina, setTituloPagina] = useState();
    const [isPhoneVersion, setIsPhoneVersion] = useState(false);
    const [idTrewa, setIdTrewa] = useState();
    const [idSolicitudPdf, setIdSolicitudPdf] = useState();
    const [numExpediente, setNumExpediente] = useState();
    const [numRegAries, setNumRegAries] = useState();

    const procedimientoActual = useSelector((state) => state.kingdomOV3.procedimientoActual);
    const solicitudActual = useSelector((state) => state.kingdomOV3.solicitudActual);
    const recibi = useSelector((state) => state.kingdomOV3.recibi);
    const numRegistroAries = useSelector((state) => state.kingdomOV3.numRegistroAries);
    const idExpTrewa = useSelector((state) => state.kingdomOV3.idExpTrewa);
    const numeroExpediente = useSelector((state) => state.kingdomOV3.numeroExpediente);

    /**
     * @function updateFormat Segun el num de pixeles del ancho de la pantalla pone version movil o version ordenador
     */
     const updateFormat = () => {
        if(window.matchMedia(`(max-width: ${appProperties.NUM_PIX_MOVIL})`).matches) {
            setIsPhoneVersion(true);
        } else {
            setIsPhoneVersion(false);
        }
    }

    /**
     * Obtiene el procedimiento en el que se encuentra para actualizar el
     * titulo de la pagina
     */
     const obtenerTituloPagina = () =>{
        let descripcion = procedimientoActual.descripcion;
        setTituloPagina(texts.TEXT_PRINCIPAL + descripcion);
        context.updateTitlePage(texts.PAGE_TITLE + descripcion);
    }

    const obtenerInfoSolicitud = () =>{
        setNumRegAries(numRegistroAries);

        if(procedimientoActual.fromPct3){
            setNumExpediente(numeroExpediente);

        }else{
            setIdTrewa(idExpTrewa);
            
            if(solicitudActual){
                setIdSolicitudPdf(solicitudActual.idMoaddSolicitudPdf);
            }
        }   
    }

    const onClickRecibi = () => {
        let linkSource = PREFIJO_OBJETO_FILE_PDF + recibi;
        let downloadLink = document.createElement("a");
        let fileName = NOMBRE_DOC_RECIBI;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }

    const onClickVolverBandeja = () => {
        history.push('/BandejaSolicitudes');
    }

    return { tituloPagina, obtenerTituloPagina, updateFormat, isPhoneVersion, obtenerInfoSolicitud, onClickRecibi, idTrewa, idSolicitudPdf, numRegAries, onClickVolverBandeja, numExpediente };

}
export default useFunctions;